import React from "react";
import { useNavigate } from "react-router-dom";
import {
  HeroSection,
  TopListSection,
  NewDishSection,
  AppDownloadSection,
  ServicesSection,
  FooterSection,
} from "../../components/visitor/sections/index.js";

/**
 * Page d'accueil visiteurs.
 * Version simplifiee: pas de fond fixe, pas d'overlays globaux.
 */
const VisitorHome = () => {
  const navigate = useNavigate();
  const goRecipes = () => navigate("/recipes");

  return (
    <div className="min-h-screen w-full overflow-x-hidden bg-gradient-to-b from-slate-950 via-slate-900 to-black">
      <div className="w-full min-w-0 px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto py-2 sm:py-4 lg:py-6">
        <div className="mb-6 sm:mb-8 lg:mb-10">
          <HeroSection onViewRecipes={goRecipes} />
        </div>

        <div className="mb-6 sm:mb-8 lg:mb-10">
          <TopListSection onViewRecipes={goRecipes} />
        </div>

        <div className="mb-6 sm:mb-8 lg:mb-10">
          <NewDishSection onViewRecipes={goRecipes} />
        </div>

        <div className="mb-6 sm:mb-8 lg:mb-10">
          <AppDownloadSection onViewRecipes={goRecipes} />
        </div>

        <div className="mb-6 sm:mb-8 lg:mb-10">
          <ServicesSection />
        </div>

        <FooterSection onViewRecipes={goRecipes} />
      </div>
    </div>
  );
};

export default VisitorHome;
